import styled from 'styled-components';

// Shared layout primitives for the full-page employee forms (Add / Edit /
// Resend Invite). Kept here so the three pages don't each re-declare them.
export const FormContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto 60px;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;
